module.exports = __webpack_public_path__ + "static/media/55.6ebfa439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/55.jpg
// module id = 588
// module chunks = 0